import { ChatbotDataContext } from 'features/chatbot/contexts/ChatbotDataLayer'
import React, { createContext, useContext, useRef } from 'react'

interface ChatbotUXContextProps {
  formRef: React.RefObject<HTMLFormElement>
  handleSubmit: () => void
  handleEnterKeyDown: (event: React.KeyboardEvent) => void
  handleSendDelphiMessage: (message: string) => void
}

export const ChatbotUXContext = createContext<ChatbotUXContextProps>(null!)

export const ChatbotUXLayer: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const formRef = useRef<HTMLFormElement>(null)
  const { sendDelphiMessage } = useContext(ChatbotDataContext)

  const handleSubmit = () => {
    if (formRef && formRef.current) {
      const event = new Event('submit', { bubbles: true, cancelable: true })
      formRef.current.dispatchEvent(event)
    }
  }

  const handleEnterKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      handleSubmit()
    }
  }

  const handleSendDelphiMessage = (message: string) => {
    sendDelphiMessage(message)
  }

  return (
    <ChatbotUXContext.Provider
      value={{
        formRef,
        handleSubmit,
        handleEnterKeyDown,
        handleSendDelphiMessage,
      }}>
      {children}
    </ChatbotUXContext.Provider>
  )
}
